import script from "./CollectivitesManagementProspects.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesManagementProspects.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesManagementProspects.vue?vue&type=style&index=0&id=f9f98d1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9f98d1a"]])

export default __exports__